'use strict';

import 'angular';

var app = angular.module('brg.config.ui.mask', [
	'ui.mask',
]);
app.config(['uiMask.ConfigProvider', function(uiMaskConfigProvider) {
	uiMaskConfigProvider.clearOnBlur(false);
	uiMaskConfigProvider.allowInvalidValue(true);
}]);
